export const ValidateAction = (data, name, type) => {
  const { fields } = data;
  const { errors } = data;
  const { helperText } = data;
  let formIsValid = true;

  switch (type) {
    case "name": {
      if (fields[name]) {
        // if (!/[a-zA-Z]/.test(fields[name])) {
        formIsValid = true; // false
        helperText[name] = true; // false
        errors[name] = false; // true
        // }
      } else {
        errors[name] = false;
        helperText[name] = false;
      }
      break;
    }
    case "img": {
      if (fields[name]) {
        const img = fields[name].split(";");
        const imgname = img[0];
        const idxDot = imgname.lastIndexOf("/") + 1;
        const extFile = imgname.substr(idxDot, imgname.length).toLowerCase();
        if (!(extFile == "png" || extFile == "jpg" || extFile == "jpeg" || extFile == "svg+xml")) {
          formIsValid = false;
          helperText[name] = false;
          errors[name] = true;
        } else {
          errors[name] = false;
          helperText[name] = false;
        }
      }
      break;
    }
    case "numbers-only": {
      if (Number.isNaN(fields[name]) || fields[name] < 0) {
        formIsValid = false;
        helperText[name] = false;
        errors[name] = true;
      } else {
        errors[name] = false;
        helperText[name] = false;
      }
      break;
    }
    case "geo-radius": {
      if (fields[name] == " " || fields[name] == null) {
        formIsValid = true;
        errors[name] = false;
        helperText[name] = false;
      } else if (fields[name] <= 29 && fields[name] !== "") {
        formIsValid = false;
        helperText[name] = true;
        errors[name] = true;
      } else {
        formIsValid = true;
        errors[name] = false;
        helperText[name] = false;
      }

      break;
    }
    // case "geo-radius": {
    //   return true;
    //   if (isNaN(fields[name]) || !/^[1-9]\d*$/.test(fields[name]) || fields[name] < 100) {
    //     if (fields[name] === "") {
    //       formIsValid = true;
    //       helperText[name] = true;
    //       errors[name] = false;
    //     } else {
    //       formIsValid = false;
    //       helperText[name] = false;
    //       errors[name] = true;
    //     }
    //   } else {
    //     errors[name] = false;
    //     helperText[name] = false;
    //   }
    //   break;
    // }
    case "longitude": {
      return true;
      // const latreg = new RegExp(/^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/);
      // const lngreg = new RegExp(/^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/);
      // if (!latreg.test(fields[name] || "")) {
      //   formIsValid = false;
      //   helperText[name] = false;
      //   errors[name] = true;
      // } else {
      //   errors[name] = false;
      //   helperText[name] = false;
      // }
      // break;
    }
    case "latitude": {
      return true;
      // const lngreg = new RegExp(/^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/);
      // if (!lngreg.test(fields[name] || "")) {
      //   formIsValid = false;
      //   helperText[name] = false;
      //   errors[name] = true;
      // } else {
      //   errors[name] = false;
      //   helperText[name] = false;
      // }
      // break;
    }
    // case "longitude": {
    //   if (isNaN(fields[name]) || fields[name] < -180 || fields[name] > 180) {
    //     formIsValid = false;
    //     helperText[name] = false;
    //     errors[name] = true;
    //   } else {
    //     errors[name] = false;
    //     helperText[name] = false;
    //   }
    //   break;
    // }
    // case "latitude": {
    //   if (isNaN(fields[name]) || fields[name] < -90 || fields[name] > 90) {
    //     formIsValid = false;
    //     helperText[name] = false;
    //     errors[name] = true;
    //   } else {
    //     errors[name] = false;
    //     helperText[name] = false;
    //   }
    //   break;
    // }
    case "email": {
      if (fields[name]) {
        if (!/^\w+([.-]?\w+)*([+]{0,1}\w+){0,1}@\w+([.-]?\w+)*(\.\w{2,15})+$/.test(fields[name])) {
          // if (!/^(\w+[+,]{0,1}\w)+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(fields[name])) {
          formIsValid = false;
          helperText[name] = false;
          errors[name] = true;
        } else {
          errors[name] = false;
          helperText[name] = false;
        }
      } else {
        errors[name] = false;
        helperText[name] = false;
      }

      break;
    }
    case "url": {
      const res = fields[name].match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g);
      if (res == null) {
        formIsValid = false;
        helperText[name] = false;
        errors[name] = "invalid url";
      } else {
        errors[name] = "";
        helperText[name] = false;
      }
      break;
    }
    case "mobile": {
      if (!fields[name]) {
        formIsValid = false;
        helperText[name] = false;
        errors[name] = true;
      } else {
        errors[name] = false;
        helperText[name] = false;
      }
      break;
      // else if (fields[name].length > 13) {
      //     formIsValid = false;
      //     helperText[name] = false;
      //     errors[name] = true;
      // }
      // else if (fields[name]) {
      //     let mobile = fields[name].split(" ");
      //     if (!mobile[1]) {
      //         formIsValid = false;
      //         helperText[name] = false;
      //         errors[name] = ErrorMessages.mobilenumber;
      //     }
      //     else if (mobile[1].length > 13) {
      //         formIsValid = false;
      //         helperText[name] = false;
      //         errors[name] = ErrorMessages.mobilenumberlength;
      //     }
      // }
    }
    case "password": {
      if (fields[name].length < 8) {
        formIsValid = false;
        helperText[name] = false;
        errors[name] = true;
      } else {
        errors[name] = false;
        helperText[name] = false;
      }
      break;
    }
    case "pan": {
      if (!fields[name]) {
        formIsValid = false;
        helperText[name] = false;
        errors[name] = true;
      } else if (!/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(fields[name])) {
        formIsValid = false;
        helperText[name] = false;
        errors[name] = true;
      } else {
        errors[name] = false;
        helperText[name] = false;
      }
      break;
    }
    case "tan": {
      if (!fields[name]) {
        formIsValid = false;
        helperText[name] = false;
        errors[name] = true;
      } else if (!/^([a-zA-Z]){4}([0-9]){5}([a-zA-Z]){1}?$/.test(fields[name])) {
        formIsValid = false;
        helperText[name] = false;
        errors[name] = true;
      } else {
        errors[name] = false;
        helperText[name] = false;
      }
      break;
    }
    default: {
      // let str = fields[name].trim();
      // if (str.length <= 0) {
      //     formIsValid = false;
      //     errors[name] = ErrorMessages.empty;
      //     helperText[name] = false;
      // }
      // else {
      //     errors[name] = "";
      //     helperText[name] = false;
      // }
      // break;
    }
  }
  return formIsValid;
};

export const ValidateReqField = (data, name, type) => {
  const { reqFields } = data;
  const { errors } = data;
  const { helperText } = data;
  let formIsValid = true;

  switch (type) {
    case "date": {
      // if (new Date(reqFields[name]).getDate() > new Date().getDate()) {
      // if (new Date(reqFields[name]) > new Date() && new Date(reqFields[name]) < new Date()) {
      // if (!((reqFields[name]).match(/^\d{2}[./-]\d{2}[./-]\d{4}$/))) {
      if (!reqFields[name]) {
        formIsValid = false;
        helperText[name] = false;
        errors[name] = true;
      } else {
        errors[name] = false;
        helperText[name] = false;
      }
      break;
    }

    case "numbers-only": {
      if (Number.isNaN(reqFields[name]) || reqFields[name] < 0) {
        formIsValid = false;
        helperText[name] = false;
        errors[name] = true;
      } else {
        errors[name] = false;
        helperText[name] = false;
      }
      break;
    }

    default: {
      const str = reqFields[name] && reqFields[name].trim();
      if (!reqFields[name] || (str && str.length <= 0)) {
        formIsValid = false;
        errors[name] = true;
        helperText[name] = false;
      } else {
        errors[name] = false;
        helperText[name] = false;
      }
    }
  }
  return formIsValid;
};

export const ValidateReqFields = (data) => {
  const { reqFields } = data;
  const { errors } = data;
  let formIsValid = true;
  Object.keys(reqFields).forEach((field) => {
    if (!reqFields[field]) {
      formIsValid = false;
      errors[field] = true;
    } else {
      Object.keys(errors).forEach((error) => {
        if (errors[error]) {
          formIsValid = false;
          errors[error] = true;
        } else {
          formIsValid = true;
          errors[error] = "";
        }
      });
    }
  });
  return formIsValid;
};

export const ValidateDropdown = (data, name) => {
  const { reqList } = data;
  const { errors } = data;
  // const { helperText } = data;
  let formIsValid = true;

  if (!reqList[name]) {
    formIsValid = false;
    errors[name] = true;
  } else {
    formIsValid = true;
    errors[name] = false;
  }
  return formIsValid;
};

export const ValidateList = (data) => {
  const { reqList } = data;
  const { errors } = data;
  let formIsValid = true;
  Object.keys(reqList).forEach((listItem) => {
    if (!reqList[listItem]) {
      formIsValid = false;
      errors[listItem] = true;
    } else {
      formIsValid = true;
      errors[listItem] = false;
    }
  });
  return formIsValid;
};

export const ValidateMultiselectList = (data, name) => {
  const { selectedOptions } = data;
  const { errors } = data;
  let formIsValid = true;

  if (selectedOptions.length <= 0) {
    formIsValid = false;
    errors[name] = true;
  } else {
    formIsValid = true;
    errors[name] = false;
  }
  return formIsValid;
};

export const ValidateMultiselectListDropDown = (data, name) =>
  new Promise((resolve) => {
    setTimeout(() => {
      const { list } = data;
      const { errors } = data;
      if (list[name].length <= 0) {
        errors[name] = true;
      } else {
        errors[name] = false;
      }
      resolve(data);
    }, 1);
  });

export const ValidateSearchDropdown = (data, name) =>
  new Promise((resolve) => {
    setTimeout(() => {
      const { reqList } = data;
      const { errors } = data;
      if (!reqList[name]) {
        errors[name] = true;
      } else {
        errors[name] = false;
      }
      resolve(data);
    }, 1);
  });

export const triallist = (data) =>
  new Promise((resolve) => {
    setTimeout(() => {
      const { reqList } = data;
      const { errors } = data;
      Object.keys(reqList).forEach((listItem) => {
        errors[listItem] = !reqList[listItem];
      });
      resolve(data);
    }, 1);
  });
